// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__YtpY5","titleContainer":"not-found_titleContainer__i2qSZ","icon":"not-found_icon__F90ct","button":"not-found_button__gBHyg"};